module.exports = __webpack_public_path__ + "static/media/logo-color.6e89c214.svg";